import { __awaiter, __decorate } from "tslib";
import { Component, Input } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { WebsiteThemeService } from "../../../../services/website-theme.service";
import { SharedHttp } from "../../../../services/http-client.service";
import { ComponentService } from "../../../../services/component.service";
import { CreateStakeComponent } from "../create-stake/create-stake.component";
import { AuthenticationWalletModalComponent } from "../../authentication-wallet-modal/authentication-wallet-modal.component";
import { UnstakeComponent } from "../unstake/unstake.component";
import { ResetMfaMessageModalComponent } from "../../reset-mfa-message-modal/reset-mfa-message-modal.component";
import { WalletDocumentExpirationModalComponent } from "../../wallet-document-expiration-modal/wallet-document-expiration-modal.component";
let StakingTabComponent = class StakingTabComponent {
    constructor(sanitizer, themeService, httpClient, compService) {
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.httpClient = httpClient;
        this.compService = compService;
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.accentColor = '';
        this.selectedCurrency = {};
        this.currencyStakes = [];
        this.stakesLoaded = false;
        this.earnings = 0;
        this.activeStakesAmount = 0;
        this.availableStakesAmount = 0;
        this.stakeStatusActive = 'ACTIVE';
        this.stakeStatusPending = 'PENDING';
        this.stakeStatusInactive = 'INACTIVE';
        this.stakeStatusWithdrawing = 'WITHDRAWING';
        this.objectKeys = Object.keys;
        this.themeService.getTheme().subscribe((data) => {
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
        });
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.setCurrency(this.stakeCurrencies[0]);
            this.stakesLoaded = true;
        });
    }
    getStakes() {
        this.httpClient.get('staking/stakes').subscribe((data) => {
            this.stakes = data['stakes'];
            this.currencyStakes = this.stakes.filter(stake => stake.currency.verboseId === this.selectedCurrency.verboseId);
            this.calculateStakingFields();
        });
    }
    setCurrency(value) {
        this.selectedCurrency = value;
        this.currencyStakes = this.stakes.filter(stake => stake.currency.verboseId === this.selectedCurrency.verboseId);
        this.calculateStakingFields();
        this.getChainInfo();
    }
    calculateStakingFields() {
        this.earnings = 0;
        this.activeStakesAmount = 0;
        this.currencyStakes.forEach(stake => {
            stake.amountInFiat = stake.amount * this.prices.usd_prices[this.selectedCurrency.verboseId.toLowerCase()];
            stake.rewardsInFiat = stake.rewards * this.prices.usd_prices[this.selectedCurrency.verboseId.toLowerCase()];
            this.earnings += stake.rewardsInFiat;
            if (stake.status === this.stakeStatusActive) {
                this.activeStakesAmount += stake.amountInFiat;
            }
        });
        const wallet = this.wallets.find(wallet => wallet.wallet.currency.verboseId === this.selectedCurrency.verboseId);
        this.availableStakesAmount = wallet ? wallet.wallet.spendableTotal * this.prices.usd_prices[this.selectedCurrency.verboseId.toLowerCase()] : 0;
    }
    createNewStake() {
        const userData = JSON.parse(localStorage.getItem('user'));
        if (userData.wallet_blocked) {
            this.compService.openModal(ResetMfaMessageModalComponent);
            return;
        }
        if (userData.block_transactions || userData.pending_for_document) {
            this.compService.openModal(WalletDocumentExpirationModalComponent);
            return;
        }
        this.compService.openModal(CreateStakeComponent, {
            stakeCurrencies: this.stakeCurrencies,
            selectedCurrency: this.selectedCurrency,
            wallets: this.wallets
        }, () => {
            this.getStakes();
            this.compService.openModal(AuthenticationWalletModalComponent, {
                authenticated: true,
                type: 'stake',
                isSuccess: true
            });
        });
    }
    unstake(stake) {
        if (!stake.unstakeEnabled || [this.stakeStatusInactive, this.stakeStatusWithdrawing].includes(stake.status)) {
            return;
        }
        const userData = JSON.parse(localStorage.getItem('user'));
        if (userData.wallet_blocked) {
            this.compService.openModal(ResetMfaMessageModalComponent);
            return;
        }
        if (userData.block_transactions || userData.pending_for_document) {
            this.compService.openModal(WalletDocumentExpirationModalComponent);
            return;
        }
        this.compService.openModal(UnstakeComponent, {
            stakeId: stake.id,
            currency: this.selectedCurrency.verboseId
        }, () => {
            this.getStakes();
            this.compService.openModal(AuthenticationWalletModalComponent, {
                authenticated: true,
                type: 'unstake',
                isSuccess: true
            });
        });
    }
    getChainInfo() {
        this.chainInfo = {};
        this.httpClient.get('staking/currency/' + this.selectedCurrency.verboseId.toLowerCase() + '/chaininfo').subscribe((data) => {
            this.chainInfo = data['chainInfo'];
        });
    }
};
StakingTabComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: SharedHttp },
    { type: ComponentService }
];
__decorate([
    Input()
], StakingTabComponent.prototype, "stakes", void 0);
__decorate([
    Input()
], StakingTabComponent.prototype, "stakeCurrencies", void 0);
__decorate([
    Input()
], StakingTabComponent.prototype, "wallets", void 0);
__decorate([
    Input()
], StakingTabComponent.prototype, "prices", void 0);
StakingTabComponent = __decorate([
    Component({
        selector: 'ecd-staking-tab',
        template: __importDefault(require("./staking-tab.component.html")).default
    })
], StakingTabComponent);
export { StakingTabComponent };
